import { render, staticRenderFns } from "./BlogPostLayout.vue?vue&type=template&id=754fee20"
import script from "./BlogPostLayout.vue?vue&type=script&lang=js"
export * from "./BlogPostLayout.vue?vue&type=script&lang=js"
import style0 from "./BlogPostLayout.vue?vue&type=style&index=0&id=754fee20&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports